import { createStore } from 'zustand'

import { CrudModalFormStore } from './interface'

export const createCrudModalFormStore = () =>
  createStore<CrudModalFormStore>((set, get) => ({
    destroyOnHidden: true,
    open: false,
    onOpenChange: undefined,
    toggleModalOpen() {
      const { open, onOpenChange } = get()
      const visible = !open
      if (onOpenChange) {
        onOpenChange(visible)
      } else {
        set({ open: visible })
      }
    }
  }))
